import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown, DatePicker, Loader } from 'core/components';
import { isSome } from 'core/utils';
import moment from 'moment';

function ExportInventoryByDateModalTemplate({
	exportInventoryByDateModalViewStore: { form, loading, sellerDropdownStore, isSuperAdminOrganization, isSeller, isDateValid },

	t,
}) {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h2 className="spc--bottom--sml">{t('Export Inventory by Date')}</h2>
				</div>
				<div className="ReactModal__body">
					<div className="spc--bottom--sml">
						<BaasicDropdown
							isDisabled={isSeller}
							dropdownStore={sellerDropdownStore}
							isClearable={true}
							label={t('Seller')}
						/>
					</div>
					<div className="spc--bottom--sml">
						<DatePicker field={form.$('date')} format={moment.localeData().longDateFormat('L')} />
					</div>
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--bottom--sml"
						type="submit"
						disabled={
							!isSome(sellerDropdownStore.value) || (!isSome(form.$('date').value) || form.$('date').value == '') || !isDateValid()
						}
					>
						<i className="fa fa-download spc--right--sml"></i>
						{t('Export Inventory')}
					</button>
				</div>
			</form>
		</section>
	);
}

export default defaultTemplate(ExportInventoryByDateModalTemplate);
